// ------------------------------------
// Modal
// ------------------------------------
(function () {
  'use strict';

  // Variáveis
  const $modal = $('.modal');
  const $btnToggle = $('[data-modal-toggle]');

  // Abre ou fecha o modal ao clicar no botão
  $btnToggle.on('click', function (ev) {
    ev.preventDefault();
    const idModal = $(this).data('modal-toggle');
    modalToggle(idModal);
  });

  // Fecha o modal ao clicar fora da caixa
  $modal.not('.modal-force, .modal-nobackdrop').on('click', function (ev) {
    if (ev.target == this) {
      modalClose($(this).attr('id'));
    }
  });

  // Fecha o modal ao pressionar a tecla ESC
  $(document).on('keyup', function (ev) {
    if (ev.keyCode == 27) {
      const $modalsOpen = $('.modal.open:not(.modal-force)');
      const modalsLength = $modalsOpen.length;
      if (modalsLength > 0) {
        const $lastModal = $($modalsOpen[modalsLength - 1]);
        modalClose($lastModal.attr('id'));
      }
    }
  });
})();

// Abre o modal
function modalOpen(idModal) {
  $('body').addClass('modal-open');
  $('#' + idModal).addClass('open');
  $('#' + idModal).trigger('modal-open');
  // Foca no elemento (Se houver)
  modalFocusEl($('#' + idModal));
}

// Fecha o modal
function modalClose(idModal) {
  $('#' + idModal).removeClass('open');
  $('#' + idModal).trigger('modal-close');
  if ($('.modal.open').length === 0) {
    $('body').removeClass('modal-open');
  }
}

// Abre ou fecha o modal
function modalToggle(idModal) {
  const $modal = $('#' + idModal);
  if ($modal.hasClass('open')) {
    modalClose(idModal);
  } else {
    modalOpen(idModal);
  }
}

// Seta o foco para um elemento ao abrir o modal
function modalFocusEl($modal) {
  let $focoEl = $modal.data('focus');
  if ($focoEl) {
    $focoEl = $($focoEl);
    setTimeout(() => {
      $focoEl.focus();
    }, 50);
  }
}

// Abre o modal de alerta
function showAlert(title, text, type, dark = false) {
  const alertIcons = {
    success: 'las la-check-circle color-success',
    danger: 'las la-times-circle color-danger',
    warning: 'las la-exclamation-circle color-warning',
    question: 'las la-question-circle',
  };
  const $modalAlert = $('#modal-alert');
  const $alertIcon = $modalAlert.find('[data-alert-icon]');
  const $alertTitle = $modalAlert.find('[data-alert-title]');
  const $alertText = $modalAlert.find('[data-alert-text]');
  const $alertBtn = $modalAlert.find('[data-alert-btn]');

  $alertIcon.removeClass().addClass(alertIcons[type]);
  $alertTitle.text(title);
  $alertText.html(text);

  // Modal editor (Estilo)
  if (dark) {
    $modalAlert.addClass('modal-lp');
    //$alertBtn.addClass('btn-transparent');
  } else {
    $modalAlert.removeClass('modal-lp');
    //$alertBtn.removeClass('btn-transparent');
  }

  modalOpen('modal-alert');
}

// Abre o modal de confirmaçao
function showConfirm(opt, dark = false) {
  const confirmIcons = {
    success: 'las la-check-circle color-success',
    danger: 'las la-times-circle color-danger',
    warning: 'las la-exclamation-circle color-warning',
    question: 'las la-question-circle',
  };
  const $modalConfirm = $('#modal-confirm');
  const $confirmIcon = $modalConfirm.find('[data-confirm-icon]');
  const $confirmTitle = $modalConfirm.find('[data-confirm-title]');
  const $confirmText = $modalConfirm.find('[data-confirm-text]');
  const $confirmBtn = $modalConfirm.find('[data-confirm-btn]');
  const $cancelBtn = $modalConfirm.find('[data-confirm-cancel-btn]');

  const confirmType = opt.type || 'question';
  const confirmTitle = opt.title || 'Confirmação';
  const confirmText = opt.text || 'Deseja realizar esta operação?';
  const cancelBtnText = opt.cancelBtnText || 'Cancelar';
  const confirmBtnText = opt.confirmBtnText || 'Confirmar';
  const confirmBtnClass = opt.confirmBtnClass || 'btn-primary';

  $confirmIcon.removeClass().addClass(confirmIcons[confirmType]);
  $confirmTitle.text(confirmTitle);
  $confirmText.html(confirmText);
  $cancelBtn.text(cancelBtnText);
  $confirmBtn.text(confirmBtnText);
  $confirmBtn.removeClass().addClass('btn btn-sm ' + confirmBtnClass);

  // Modal editor (Estilo)
  if (dark) {
    $modalConfirm.addClass('modal-lp');
    //$cancelBtn.addClass('btn-transparent');
  } else {
    $modalConfirm.removeClass('modal-lp');
    //$cancelBtn.removeClass('btn-transparent');
  }

  modalOpen('modal-confirm');

  $confirmBtn.off('click').on('click', function (ev) {
    ev.preventDefault();
    modalClose('modal-confirm');
    if (typeof opt.callback === 'function') {
      opt.callback();
    }
  });
}
